import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";

const API = "/api";

function FranchiseAutoLogin() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("Opening franchise dashboard...");

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setMessage("Login token missing");
      return;
    }

    const runLogin = async () => {
      try {
        const res = await axios.post(`${API}/franchise-token-login`, { token });
        if (res.data?.status === "success") {
          localStorage.setItem("franchise", JSON.stringify(res.data.user));
          localStorage.setItem("franchiseLastActiveAt", String(Date.now()));
          navigate("/franchise-dashboard", { replace: true });
          return;
        }
        setMessage("Franchise login failed");
      } catch (error) {
        setMessage(error.response?.data?.message || "Login link expired or invalid");
      }
    };

    runLogin();
  }, [navigate, params]);

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#f8fafc", color: "#0f172a" }}>
      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "18px", padding: "24px", boxShadow: "0 18px 38px rgba(15,23,42,.08)" }}>
        <strong>{message}</strong>
      </div>
    </div>
  );
}

export default FranchiseAutoLogin;
